(() => {
  'use strict';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup(root = document) {
    root.querySelectorAll('[data-hb-carousel]').forEach((carousel) => {
      if (carousel.dataset.ready) return;
      const track = carousel.querySelector('[data-hb-track]');
      const previous = carousel.querySelector('[data-hb-prev]');
      const next = carousel.querySelector('[data-hb-next]');
      const counter = carousel.querySelector('[data-hb-counter]');
      const progress = carousel.querySelector('[data-hb-progress]');
      if (!track || !previous || !next) return;
      carousel.dataset.ready = 'true';
      const update = () => {
        const cards = [...track.children];
        if (!cards.length) return;
        const step = cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        const first = Math.max(0, Math.round(track.scrollLeft / step));
        const visible = Math.max(1, Math.round((track.clientWidth + (parseFloat(getComputedStyle(track).columnGap) || 0)) / step));
        previous.disabled = track.scrollLeft < 5;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
        if (counter) counter.textContent = `${String(first + 1).padStart(2, '0')} — ${String(Math.min(cards.length, first + visible)).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
        if (progress) progress.style.width = `${Math.min(100, ((first + visible) / cards.length) * 100)}%`;
      };
      const move = (direction) => track.scrollBy({ left: direction * track.clientWidth, behavior: reducedMotion() ? 'auto' : 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      if (window.ResizeObserver) new ResizeObserver(update).observe(track);
      update();
    });
    root.querySelectorAll('[data-hb-header]').forEach((header) => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';
      header.querySelectorAll('[data-hb-dropdown]').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          header.querySelectorAll('[data-hb-dropdown][open]').forEach((other) => {
            if (other !== details && !other.contains(details) && !details.contains(other)) other.open = false;
          });
        });
      });
      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details[open]');
        if (details) { details.open = false; details.querySelector('summary')?.focus(); }
      });
      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();